import React, { useEffect, useState,useRef  } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import {
  collection,
  addDoc,
  serverTimestamp,
  doc,
  getDoc,
  query,
  orderBy,
  startAt,
  endAt,
  limit,
  getDocs
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { increment, updateDoc,where } from "firebase/firestore";

import BackHomeButton from "../components/BackHomeButton";

const Email_Worksheet = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const fileId = location.state?.fileId;
  const fileUrl = location.state?.fileUrl

  const [worksheet, setWorksheet] = useState(null);
  const [loadingFile, setLoadingFile] = useState(true);

  const [friendName, setFriendName] = useState("");
  const [friendEmail, setFriendEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const functions = getFunctions();
const sendEmail = httpsCallable(functions, "sendWorksheetEmail");

const MAX_PER_MINUTE = 1;
const WINDOW_TIME = 60 * 1000; // 3 minute

const [email, setEmail] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const wrapperRef = useRef(null);
  const debounceRef = useRef(null);

  // 🔹 Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

   // 🔹 Debounced Firestore Query
  const handleChange = (e) => {
    const value = e.target.value.toLowerCase();
    setEmail(value);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    if (value.length < 2) {
      setSuggestions([]);
      return;
    }

    debounceRef.current = setTimeout(async () => {
      try {
        setLoading(true);

        const q = query(
          collection(db, "profiles"),
          orderBy("email"),
          startAt(value),
          endAt(value + "\uf8ff"),
          limit(10) // 🔥 Only top 10
        );

        const querySnapshot = await getDocs(q);

        const results = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setSuggestions(results);
      } catch (error) {
        console.error("Error fetching emails:", error);
      } finally {
        setLoading(false);
      }
    }, 400); // 🔥 400ms debounce
  };

    const handleSelect = (selectedEmail) => {
    setEmail(selectedEmail);
    setFriendEmail(selectedEmail);
    setSuggestions([]);
  };


function canSendEmail() {
  const now = Date.now();

  const stored = JSON.parse(localStorage.getItem("emailRate")) || {
    count: 0,
    startTime: now,
  };

  // Reset window if expired
  if (now - stored.startTime > WINDOW_TIME) {
    localStorage.setItem(
      "emailRate",
      JSON.stringify({ count: 1, startTime: now })
    );
    return true;
  }

  // Block if exceeded
  if (stored.count >= MAX_PER_MINUTE) {
    return false;
  }

  // Increment
  stored.count += 1;
  localStorage.setItem("emailRate", JSON.stringify(stored));

  return true;
}

  // 🔥 Fetch from uploads collection
  useEffect(() => {
    const fetchWorksheet = async () => {
      if (!fileId) return;

      try {
        const docRef = doc(db, "uploads", fileId);
        const snap = await getDoc(docRef);

        if (snap.exists()) {
          setWorksheet({ id: snap.id, ...snap.data() });
        }
      } catch (error) {
        console.error("Error fetching worksheet:", error);
      } finally {
        setLoadingFile(false);
      }
    };

    fetchWorksheet();
  }, [fileId]);

    // 🔥 Fetch from uploads collection using fileUrl
  useEffect(() => {
    const fetchWorksheet = async () => {
      if (!fileUrl) return;
      
      //alert(fileUrl);

      try {
          const q = query(
            collection(db, "uploads"),
            where("fileUrl", "==", fileUrl)
          );

          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const docSnap = querySnapshot.docs[0];
            setWorksheet({ id: docSnap.id, ...docSnap.data() });
          }
      } catch (error) {
        //console.log("Error fetching worksheet:", error);
      } finally {
        setLoadingFile(false);
      }
    };

    //alert(fileUrl);

    fetchWorksheet();
  }, [fileUrl]);

 const handleShare = async (e) => {
  e.preventDefault();

  if (!friendName.trim() || !friendEmail.trim()) {
    //alert(friendName.trim());
    //alert(friendEmail.trim());
    alert("Please fill required fields");
    return;
  }

  // ✅ FRONTEND RATE LIMIT CHECK
  if (!canSendEmail()) {
    alert("Please wait before sending more emails.");
    return;
  }

  if (!worksheet) {
    alert("Worksheet not loaded yet.");
    return;
  }

  try {
    setLoading(true);

    // 1️⃣ Send email FIRST
    const result = await sendEmail({
      friendName,
      friendEmail,
      worksheetTitle: worksheet.fileName,
      fileUrl: worksheet.fileUrl,
      message,
    });

    //console.log("Email result:", result.data);

    // 2️⃣ Increment share count in uploads collection
        const uploadRef = doc(db, "uploads", worksheet.id);
        await updateDoc(uploadRef, {
          shares: increment(1),
        });

    // 2️⃣ Save to Firestore
    await addDoc(collection(db, "Shared_Worksheets"), {
      worksheetId: worksheet.id,
      fileUrl: worksheet.fileUrl,
      fileName: worksheet.fileName,
      standard: worksheet.standard,
      subject: worksheet.subject,
      school: worksheet.school,
      city: worksheet.city,
      sharedBy: auth.currentUser?.uid,
      sharedByEmail: auth.currentUser?.email,
      friendName,
      friendEmail,
      message,
      createdAt: serverTimestamp(),
    });

    setSuccess(true);
    setFriendName("");
    setFriendEmail("");
    setEmail("");
    setMessage("");
  } catch (error) {
    console.error("Share error:", error);
    alert(error.message);
  } finally {
    setLoading(false);
  }
};

  if (!fileId && !fileUrl) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        No worksheet selected.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 flex items-center justify-center px-4">      

      <div className="w-full max-w-lg bg-white rounded-2xl shadow-xl p-8">

        <BackHomeButton></BackHomeButton>

        {/* Header */}
        <div className="text-center mb-6">
          <h2 className="text-xl font-semibold text-gray-800">
            Share Worksheet
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            Send this worksheet to a friend
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleShare} className="space-y-4">

          <input
            type="text"
            placeholder="Friend's Name"
            value={friendName}
            onChange={(e) => setFriendName(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />

          <div ref={wrapperRef} className="relative w-full">
            <input
              type="email"
              value={email}
              onChange={handleChange}
              placeholder="Enter Friends email"
              className="w-full border border-gray-300 rounded-md p-2"
            />

            {loading && (
              <div className="absolute right-3 top-3 text-xs text-gray-400">
                Searching...
              </div>
            )}

            {suggestions.length > 0 && (
              <div className="absolute z-20 w-full bg-white border border-gray-200 rounded-md mt-1 shadow-md max-h-60 overflow-y-auto">
                {suggestions.map((profile) => (
                  <div
                    key={profile.id}
                    onClick={() => handleSelect(profile.email)}
                    className="p-2 hover:bg-gray-100 cursor-pointer"
                  >
                    <div className="font-medium">{profile.email}</div>
                    <div className="text-xs text-gray-500">
                      Name: {profile.name} • {profile.school} • Standard: {profile.standard} 
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <textarea
            placeholder="Optional message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows="3"
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-lg text-sm font-medium transition"
          >
            {loading ? "Sharing..." : "Share Worksheet"}
          </button>
        </form>

        {/* ✅ Worksheet Details Preview */}
        {!loadingFile && worksheet && (
          <div className="mt-6 border border-gray-200 rounded-xl p-4 bg-gray-50">

            <h3 className="text-sm font-semibold text-gray-700 mb-2">
              Worksheet Details
            </h3>

            <p className="text-sm font-semibold text-gray-800">
              {worksheet.fileName}
            </p>

            <p className="text-xs text-gray-500 mt-1">
              Standard : {worksheet.standard} • Subject : {worksheet.subject}
            </p>

            <p className="text-xs text-gray-500">
              School :{worksheet.school}, {worksheet.city}
            </p>

            <p className="text-xs text-gray-500 mt-1">
              Downloads: {worksheet.downloads} | Rating: {worksheet.avgRating}⭐
            </p>

            {worksheet.topicName?.current && (
              <div className="mt-2 flex flex-wrap gap-1">
                {worksheet.topicName.current.slice(0, 4).map((topic, i) => (
                  <span
                    key={i}
                    className="text-[10px] bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full"
                  >
                    {topic}
                  </span>
                ))}
              </div>
            )}

          </div>
        )}

        {success && (
          <div className="mt-4 text-center text-green-600 text-sm">
            ✔ Worksheet shared successfully Over Gmail
          </div>
        )}

        <div className="mt-6 text-center">
          <button
            onClick={() => navigate(-1)}
            className="text-xs text-gray-500 hover:text-gray-700"
          >
            ← Go Back
          </button>
        </div>

      </div>
    </div>
  );
};

export default Email_Worksheet;